/* eslint-disable no-shadow */
import CreditMemoModel from '@/common/models/credit-memo-model';
import InvoiceModel from '@/common/models/invoice-model';
import TransactionModel from '@/common/models/transaction-model';

export const state = {
    creditMemo: new CreditMemoModel(),
    transactions: [],
    invoices: [],
};

export const actions = ({api}) => ({
    async fetchCreditMemo({commit}, creditMemoId) {
        const params = {id: creditMemoId};
        const creditMemoData = await api(({creditMemos}) => creditMemos.get(params));
        commit('setCreditMemo', creditMemoData);
    },

    async fetchTransactions({commit}, transactionIds) {
        if (transactionIds.length === 0) {
            commit('clearTransactions');
            return;
        }
        const params = {
            filter: `id:${transactionIds.join(',')}`,
        };
        const transactionsData = await api(({transactions}) => transactions.getAll(params));
        commit('setTransactions', transactionsData);
    },

    async fetchInvoices({commit}, invoiceIds) {
        const params = {
            filter: `id:${invoiceIds.join(',')}`,
            expand: 'organization,items.*.product',
        };
        const invoicesData = await api(({invoices}) => invoices.getAll(params));
        commit('setInvoices', invoicesData);
    },
});

export const mutations = {
    setCreditMemo(state, creditMemoData) {
        const {fields: creditMemoFields} = creditMemoData;
        state.creditMemo = new CreditMemoModel(creditMemoFields);
    },
    setTransactions(state, transactionsData) {
        const {items: transactionItems} = transactionsData;
        state.transactions = transactionItems.map(({fields}) => new TransactionModel(fields));
    },
    clearTransactions(state) {
        state.transactions = [];
    },
    setInvoices(state, invoicesData) {
        const {items: invoiceObjects} = invoicesData;
        state.invoices = invoiceObjects.map(({fields}) => new InvoiceModel(fields));
    },
};

export const getters = {
    firstInvoice: (state) => {
        const [invoiceModel] = state.invoices;

        return invoiceModel;
    },
    overpaymentTransaction: state => state.transactions
        .filter(transaction => state.creditMemo.originTransactionIds.includes(transaction.id))
        .find(transaction => transaction.isSaleType),
    refundTransactions: state => state.transactions
        .filter(transaction => state.creditMemo.refundTransactionIds.includes(transaction.id)),
    reversalTransactions: state => state.transactions
        .filter(transaction => state.creditMemo.reversalTransactionIds.includes(transaction.id)),
};
